<template>
  <div class="wrapper">
    <div class="left">
      <div class="left-pic"></div>
    </div>
    <div class="right">
      <el-form ref="loginForm" :model="formData" :rules="loginRules" class="login-form" auto-complete="off" label-position="left">
        <div class="title">suni-专业外贸站询盘管理系统</div>
        <el-form-item prop="username">
          <el-input
            ref="name"
            v-model="formData.username"
            autofocus="autofocus"
            name="username"
            type="text"
            auto-complete="off"
            placeholder="请输入用户名"
            @keyup.enter.native="loginByUserName"
          />
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="formData.password" type="password" name="password" auto-complete="off" placeholder="请输入密码" @keyup.enter.native="loginByUserName" />
        </el-form-item>
        <el-form-item>
          <el-button :loading="loading" class="submit-btn" @click.native.prevent="loginByUserName">
            登录
          </el-button>
        </el-form-item>
      </el-form>
      <div class="copyright">
        <a target="_blank" href="https://waimaoxpt.com/">&copy;2024 外贸询盘通 (suni)</a>
      </div>
    </div>
    <img :src="logo" class="logo" />
  </div>
</template>

<script>
//import { login } from "@/api/login"
export default {
  data() {
    const validateUsername = (rule, value, callback) => {
      if (value.length == 0) {
        callback(new Error("请输入账号"))
      } else {
        callback()
      }
    }
    const validatePass = (rule, value, callback) => {
      if (value.length < 5) {
        callback(new Error("密码不能小于5位"))
      } else {
        callback()
      }
    }
    return {
      logo: require("../../assets/images/logo.png"),
      formData: {
        username: "",
        password: ""
      },
      loginRules: {
        username: [{ required: true, trigger: "blur", validator: validateUsername }],
        password: [{ required: true, trigger: "blur", validator: validatePass }]
      },
      loading: false,
      redirect: undefined,
      remember: false
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  methods: {
    // handleLogin() {
    //   this.$refs.loginForm.validate(valid => {
    //     if (valid) {
    //       this.loading = true
    //       this.$store
    //         .dispatch("Login", this.loginForm)
    //         .then(res => {
    //           this.loading = false
    //           this.$router.push({ path: this.redirect || "/" })
    //         })
    //         .catch(() => {
    //           this.loading = false
    //         })
    //     } else {
    //       return false
    //     }
    //   })
    // }
    loginxx() {
      this.$http.post("/permission/getMenu", this.formData).then(res => {
        res = res.data
        if (res.code === 20000) {
          this.loading = true
          //this.$message.success(res.data.message)
          //获取menu,并保存
          this.$store.commit("clearMenu")
          this.$store.commit("setMenu", res.data.menu)
          //存储token
          this.$store.commit("setToken", res.data.token)
          //set动态路由
          this.$store.commit("addRouter", this.$router)
          //路由跳转
          this.$router.push({ path: "/" })
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    loginByUserName() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store
            .dispatch("LoginByUsername", this.formData)
            .then(res => {
              if (res.code === 20000) {
                //存储一些用户信息到前端sessionStorage便于使用，比如上次登录时间，上次登录ip等
                //console.log(res.data.userinfo)
                localStorage.setItem("user_info_last", JSON.stringify(res.data.userinfo))
                //this.$router.push({ path: "/" })
                //console.log("登录时候 :", JSON.stringify(res.data.userinfo))
                this.$router.push({ path: this.redirect || "/" })
                //this.loading = false
              } else {
                //console.log("i am hrer")
                this.$message.error(res.message)
                this.loading = false
              }
            })
            .catch(() => {
              this.loading = false
            })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
$dark_gray: #ccc;
$light_gray: #333;
$login_theme: #00274f;

::v-deep input {
  border: 0 none;
  background-color: white;
  -webkit-appearance: none;

  &:-webkit-autofill {
    background-image: none;
    -webkit-box-shadow: 0 0 0 1000px white inset !important;
    -webkit-text-fill-color: $light_gray !important;
  }
}

::v-deep .el-input__inner {
  height: 40px;
  padding: 0 12px;
  background-color: white;
  border: 0 none;
  border-bottom: 1px solid #e6e6e6 !important;
}

::v-deep .el-form-item__error {
  left: 12px;
}

.wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  min-width: 1300px;
  display: flex;

  .left {
    width: 68%;

    .left-pic {
      width: 100%;
      height: 100%;
      background: url("../../assets/images/aa.jpg") no-repeat center;
      background-size: cover;
    }
  }

  .right {
    position: relative;
    width: 32%;
    background-color: #fff;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-top: 6%;

    .el-form {
      width: 70%;

      .title {
        font-size: 26px;
        color: $light_gray;
        margin: 0 auto 50px;
        text-align: center;
      }

      .submit-btn {
        width: 100%;
        line-height: 2;
        font-size: 16px;
        color: white;
        border-radius: 3px;
        background-color: $login_theme;
        display: block;
      }

      .el-button {
        border: 0 none;
      }

      .action-control {
        color: #999;

        ::v-deep .el-checkbox {
          .el-checkbox__label {
            color: #999;
          }

          .el-checkbox__input.is-checked .el-checkbox__inner {
            background-color: $login_theme;
            border-color: $login_theme;
          }
        }

        .forget {
          cursor: pointer;
          float: right;
        }
      }
    }

    .register {
      width: 70%;
      padding-top: 30px;
      color: $light_gray;
      border-top: 1px solid #e6e6e6;
      text-align: center;
      margin-top: 28px;

      .register-btn {
        color: $login_theme;
        cursor: pointer;
      }
    }

    .copyright {
      width: 92%;
      position: absolute;
      bottom: 2%;
      color: #b4b3b3;
      font-size: 16px;
      text-align: center;
      line-height: 1.5;
    }
  }

  .logo {
    position: absolute;
    left: 60px;
    top: 50px;
    width: 180px;
    height: 48px;
    z-index: 200;
  }
}
</style>
